import PrivacyPolicyPage from '../components/LegalPages/components/PrivacyPolicyPage';
import { publicMeta } from './public-meta';

export const meta = publicMeta('Privacy Policy | Cartwheel');

export default PrivacyPolicyPage;
